import VendorInformationLayout from "./VendorInformationLayout";
import { vendorInformationData } from "./vendorInformation.data";
import { useScrollToSection } from "@/hooks/useScrollToSection";

export const VendorInformationTemplate = () => {
  const { ref } = useScrollToSection<HTMLElement>({
    behavior: "smooth",
    block: "start",
    offset: 80,
  });

  return (
    <>
      <section
        ref={ref}
        id="vendor-information"
        className="contact-form bg-white"
      >
        <div className="container mx-auto mt-8 px-4">
          {vendorInformationData.map((section, idx) => (
            <div className="mb-8" key={idx}>
              <VendorInformationLayout
                heading={section.heading}
                content={section.content}
                className="mb-1"
              />
            </div>
          ))}
        </div>
      </section>
    </>
  );
};
export default VendorInformationTemplate;
